import { uniqueId } from "lodash";
import React from "react";
import { FormGroup, Input, UncontrolledTooltip } from "reactstrap";
import "./ToggleSwitch.scss";

function ToggleSwitch({
  name,
  label,
  inverted,
  disabled,
  datagroup,
  parentgroup,
  childgroup,
  tooltip,
  error,
  ...rest
}) {
  const id = uniqueId(`${name}-`);
  const labelId = `${id}-label`;
  return (
    <FormGroup className="mb-0">
      <div className="custom-control custom-switch">
        <Input
          {...rest}
          name={name}
          disabled={disabled}
          inverted={inverted ? "inverted" : null}
          id={id}
          type="checkbox"
          datagroup={datagroup}
          parentgroup={parentgroup}
          childgroup={childgroup}
          className="custom-control-input"
        />
        <label className="custom-control-label" htmlFor={id} id={labelId}>
          {label}
        </label>
        {tooltip && (
          <UncontrolledTooltip placement="top" target={labelId}>
            {tooltip}
          </UncontrolledTooltip>
        )}
      </div>
    </FormGroup>
  );
}

export default ToggleSwitch;
